/**
파일명: App.js
설명: 앱의 최상위 조립 지점으로 라우팅 상태와 공통 레이아웃/페이지 라우터를 연결합니다.
*/

import { useEffect } from 'react';
import { useAppRouter } from './hooks/useAppRouter';
import MainLayout from './layouts/MainLayout';
import PageRouter from './pages/PageRouter';

export default function App() {
  // [비즈니스] URL 변경에 따라 올바른 페이지를 노출해 사용자의 탐색 흐름을 유지합니다.
  // [기능] 라우팅 훅에서 현재 경로, 파싱된 라우트, 이동 함수를 조회합니다.
  // [기술] 파생 상태(route)를 useAppRouter 내부에서 계산해 App은 조립 책임만 유지합니다.
  const { pathname, route, navigate } = useAppRouter();

  // [비즈니스] 폐기된 구 URL로 들어온 방문자를 새 경로로 자동 전환합니다.
  // [기술] replace로 이동해 히스토리에 구 URL을 남기지 않습니다.
  //        pushState를 쓰면 뒤로가기 → 구 URL → 다시 전환의 루프가 생깁니다.
  const redirectTo = route.page === 'redirect' ? route.to : null;
  useEffect(() => {
    if (redirectTo) navigate(redirectTo, { replace: true });
  }, [redirectTo]); // eslint-disable-line react-hooks/exhaustive-deps

  // [기술] 전환이 확정되기 전 한 프레임 동안 빈 화면을 보여 깜빡임을 줄입니다.
  if (redirectTo) return null;

  // [비즈니스] 관리자 콘솔은 공개 사이트의 헤더/푸터 없이 전체 화면을 작업 공간으로 사용합니다.
  const isAdminConsole = route.page === 'admin';

  return (
    <MainLayout pathname={pathname} onNavigate={navigate} hideChrome={isAdminConsole}>
      <PageRouter route={route} onNavigate={navigate} />
    </MainLayout>
  );
}
